module.exports = __webpack_public_path__ + "static/content_image_1-62dec3fa480f8dc65ce72bbb68db922d.svg";